import CallToActionBlock from 'libs/wordpress/content/cmsBlocks/CallToActionBlock';
import React from 'react';
import moduleMargins from 'config/theme/moduleMargins';
import styled from 'libs/styled';

const Section = styled('section')``;

const CallToActionModule = ({ ...rest }) => (
    <Section my={moduleMargins.md}>
        <CallToActionBlock {...rest} />
    </Section>
);

export default CallToActionModule;
